export const DATE_FORMATS = {
  long: 'yyyy.MM.dd - HH:mm',
  short: 'yyyy.MM.dd',
  time: 'HH:mm',
} as const;

export type DateFormatKey = keyof typeof DATE_FORMATS;
export type DateFormat = (typeof DATE_FORMATS)[DateFormatKey];

export const DATE_FORMAT_LONG: DateFormat = DATE_FORMATS.long;
